export default __webpack_public_path__ + "static/media/word.dda7dbf2.png";